const DEFER_KEY = "passkey-setup-deferred-until";
const COMPLETED_KEY = "passkey-setup-completed";
const DEFERRAL_MS = 14 * 24 * 60 * 60 * 1000;

function safeStorage(): Storage | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function deferPasskeySetup(): void {
  const storage = safeStorage();
  if (!storage) return;
  try {
    storage.setItem(DEFER_KEY, String(Date.now() + DEFERRAL_MS));
  } catch {
    // ignore — quota or privacy mode
  }
}

export function isPasskeySetupDeferred(): boolean {
  const storage = safeStorage();
  if (!storage) return false;
  try {
    const raw = storage.getItem(DEFER_KEY);
    if (!raw) return false;
    const until = Number(raw);
    if (!Number.isFinite(until)) {
      storage.removeItem(DEFER_KEY);
      return false;
    }
    if (Date.now() >= until) {
      storage.removeItem(DEFER_KEY);
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

/**
 * Marks passkey setup as "done on this browser". Persists indefinitely so we
 * don't nag a user who has already registered a local passkey or just used
 * one to sign in here. Scoped to this browser — a different device / profile
 * gets its own prompt even if the account already has passkeys elsewhere.
 */
export function markPasskeySetupCompleted(): void {
  const storage = safeStorage();
  if (!storage) return;
  try {
    storage.setItem(COMPLETED_KEY, "1");
  } catch {
    // ignore
  }
}

export function isPasskeySetupCompleted(): boolean {
  const storage = safeStorage();
  if (!storage) return false;
  try {
    return storage.getItem(COMPLETED_KEY) === "1";
  } catch {
    return false;
  }
}
